<ul role="menu">

  @if (displayMenu && topMenu) {
    @for (section of topMenu.sections; track section; let i = $index) {
      <li #menubutton id="section-{{i}}" class="navbar-item top">
        @if (!section.groups) {
          <a [routerLink]="[ '/', 'dashboard' ]" class="navbar-link" role="menuitem" aria-expanded="false">
            <span class="header-icon-large {{section.icon}}"></span>
            <span class="menu-label">{{section.title}}</span>
          </a>
        }
        @if (section.groups) {
          <div class="btn-group" dropdown >
            <button dropdownToggle type="button" class="btn btn-secondary btn-sm preferences-button navbar-link"
              [attr.aria-controls]="'button-group-' + i">
              @if (!section.usephoto) {
                <span class="header-icon-large {{section.icon}}"></span>
              }
              @if (section.usephoto) {
                <img class="avatar rounded-circle" alt="View account"
                  [src]="avatar| domSanitizerPipe: 'src'" />
              }
              <div>
                <span class="menu-label">{{section.title}} <span
                class="header-icon-small icon-gecko-scroll-down"></span>
              </span>
            </div>
          </button>
          <ul #submenus id="submenu-{{i}}" *dropdownMenu class="dropdown-menu dropdown-menu-dynamic"
            [ngClass]="menuCssClass" role="menu" aria-labelledby="button-studies">
            <div [ngStyle]="{'min-width': section.groups.length*250+ 'px', 'overflow': 'hidden'}"
              style="min-width: 900px;" class="row studies-row">
              @for (group of section.groups; track group) {
                <div class="col-12"
                  [ngClass]="(section.groups.length==2)? 'col-lg-6': (section.groups.length==3)? 'col-lg-4' : 'col-lg-3'">
                  <li class="column"><span
                    [ngStyle]="{'border-bottom': !group.items? 'none': '1px solid #5b6770'}"
                    [ngClass]="{'menu-header': group.title}" data-toggle="tooltip"
                  data-placement="bottom">{{group.title}}</span>
                  @if (group.text) {
                    <div [innerHTML]="group.text"></div>
                  }
                  @if (group.items) {
                    <ul>
                      @for (item of group.items; track item) {
                        <li class="navbar-item subitem" role="none">
                          @if (!item.isConnectUsLink) {
                            <a role="menuitem"
                            href="{{item.link}}">{{item.title}}</a>
                          }
                          @if (item.isConnectUsLink) {
                            <a role="menuitem"
                            [routerLink]="[item.link]">{{item.title}}</a>
                          }
                        </li>
                      }
                    </ul>
                  }
                </li>
              </div>
            }
          </div>
        </ul>
      </div>
    }
  </li>
}
}


@if (displayOfflineMenu) {
  <li class="navbar-item top left-border">
    <div class="btn-group" dropdown [ngStyle]="{'display': isOffline ? '' : '' }" [@offlineTriggered]="isOffline">
      <button id="button-offline" dropdownToggle type="button"
        class="btn btn-secondary btn-sm preferences-button navbar-link" aria-controls="dropdown-offline"
        style="min-width: 80px;">
        @if (isOffline) {
          <img class="avatar" src="../../../../assets/img/offline-col.svg" alt="offline image">
        }
        @if (!isOffline) {
          <img class="avatar" src="../../../../assets/img/online-col.svg" alt="online image">
        }
        <div>
          @if (!isOffline) {
            <span class="menu-label">Online
              <span class="header-icon-small icon-gecko-scroll-down"></span>
            </span>
          }
          @if (isOffline) {
            <span class="menu-label">Offline
              <span class="header-icon-small icon-gecko-scroll-down"></span>
            </span>
          }
        </div>
      </button>
      <ul id="dropdown-offline-dropdown" *dropdownMenu class="dropdown-menu dropdown-menu-right special-dropdown"
        role="menu" aria-labelledby="button-offline">
        <li class="column">
          <ul>
            @if (!isOffline) {
              <div class="dropdown-header" style="padding-top: 18px !important;">
                <strong>You are in online
                mode</strong></div>
              }
              @if (isOffline) {
                <div class="dropdown-header" style="padding-top: 18px !important;"><strong>You
                  are in offline
                mode</strong></div>
              }
              @if (isOffline && isWorkingOffline && !noInternetConnection) {
                <li role="menuitem" class="link"
                  style="padding-left: 20px !important;" (click)="goOnline()">
                  <img class="avatar" src="../../../../assets/img/online-col-blue.svg" alt="online image"
                    style="max-height: 25px; max-width: 30px"> Go
                    online now
                  </li>
                }
                @if (noInternetConnection) {
                  <li role="menuitem"
                    style="padding-left: 23px !important; padding-bottom: 10px !important;">
                    No internet connection available
                  </li>
                }
                @if (!isOffline) {
                  <li role="menuitem" class="link" style="padding-left: 20px !important;"
                    (click)="goOffline()">
                    <img class="avatar" src="../../../../assets/img/offline-col-blue.svg" alt="offline image"
                      style="max-height: 25px; max-width: 30px">
                      Go
                      offline now
                    </li>
                  }
                  @if (!isOffline) {
                    <li>
                      <div style="text-align: center;" [ngClass]="{'online-offline-options': !isOffline}">
                        @if (supportsServiceWorkers) {
                          <span>
                            @if (!isOffline) {
                              <li role="none" role="menuitem" class="link" (click)="popUpOffline()">
                                <a style="margin-top: 5px;" class="menuitem">Offline options</a>
                              </li>
                            }
                          </span>
                        }
                      </div>
                    </li>
                  }
                </ul>
              </li>
            </ul>
          </div>
        </li>
      }
    </ul>